(function () {
  'use strict';

  if (window.AuthenticityVideoPopup && typeof window.AuthenticityVideoPopup.initAllSections === 'function') {
    window.AuthenticityVideoPopup.initAllSections();
    return;
  }

  var SELECTORS = {
    section: '[data-auth-video-section]',
    trigger: '[data-auth-video-trigger]',
    modal: '[data-auth-video-modal]',
    close: '[data-auth-video-close]',
    player: '[data-auth-video-player]',
    sourcesTemplate: '[data-auth-video-sources]',
    dialog: '.auth-video__modal-dialog'
  };

  var CLASSES = {
    open: 'is-open',
    loading: 'is-loading',
    bodyOpen: 'auth-video-modal-open',
    portrait: 'is-portrait',
    landscape: 'is-landscape',
    dialogPortrait: 'auth-video__modal-dialog--portrait',
    dialogLandscape: 'auth-video__modal-dialog--landscape',
    videoPortrait: 'auth-video__video--portrait',
    videoLandscape: 'auth-video__video--landscape'
  };

  var state = {
    activeModal: null,
    lastFocusedElement: null,
    closeTimer: null,
    scrollLocked: false,
    htmlOverflow: '',
    htmlScrollBehavior: '',
    bodyOverflow: '',
    bodyPaddingRight: '',
    bodyTouchAction: ''
  };

  function getFocusableElements(container) {
    if (!container) return [];

    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
  }

  function syncVisualViewport(modal) {
    if (!modal) return;

    var viewport = window.visualViewport;

    if (viewport) {
      modal.style.setProperty('--auth-video-vv-top', Math.max(0, viewport.offsetTop) + 'px');
      modal.style.setProperty('--auth-video-vv-left', Math.max(0, viewport.offsetLeft) + 'px');
      modal.style.setProperty('--auth-video-vv-width', viewport.width + 'px');
      modal.style.setProperty('--auth-video-vv-height', viewport.height + 'px');
      return;
    }

    modal.style.setProperty('--auth-video-vv-top', '0px');
    modal.style.setProperty('--auth-video-vv-left', '0px');
    modal.style.setProperty('--auth-video-vv-width', window.innerWidth + 'px');
    modal.style.setProperty('--auth-video-vv-height', window.innerHeight + 'px');
  }

  function lockBodyScroll(shouldLock) {
    if (shouldLock) {
      if (state.scrollLocked) return;

      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      state.scrollLocked = true;
      state.htmlOverflow = document.documentElement.style.overflow;
      state.htmlScrollBehavior = document.documentElement.style.scrollBehavior;
      state.bodyOverflow = document.body.style.overflow;
      state.bodyPaddingRight = document.body.style.paddingRight;
      state.bodyTouchAction = document.body.style.touchAction;

      document.documentElement.style.scrollBehavior = 'auto';
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
      document.body.classList.add(CLASSES.bodyOpen);

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = scrollbarWidth + 'px';
      }

      return;
    }

    if (!state.scrollLocked) return;

    document.documentElement.style.overflow = state.htmlOverflow;
    document.documentElement.style.scrollBehavior = state.htmlScrollBehavior;
    document.body.style.overflow = state.bodyOverflow;
    document.body.style.paddingRight = state.bodyPaddingRight;
    document.body.style.touchAction = state.bodyTouchAction;
    document.body.classList.remove(CLASSES.bodyOpen);

    state.scrollLocked = false;
  }

  function appendModalToBody(modal) {
    if (!modal || modal.parentElement === document.body) return;
    document.body.appendChild(modal);
  }

  function loadVideoSources(modal) {
    var player = modal.querySelector(SELECTORS.player);
    var template = modal.querySelector(SELECTORS.sourcesTemplate);

    if (!player || !template || player.dataset.authVideoLoaded === 'true') return;

    player.appendChild(template.content.cloneNode(true));
    player.dataset.authVideoLoaded = 'true';
    player.load();
  }

  function applyVideoOrientation(player, orientation) {
    var modal = player.closest(SELECTORS.modal);
    var dialog = modal ? modal.querySelector(SELECTORS.dialog) : null;

    player.classList.remove(CLASSES.portrait, CLASSES.landscape, CLASSES.videoPortrait, CLASSES.videoLandscape);

    if (dialog) {
      dialog.classList.remove(CLASSES.dialogPortrait, CLASSES.dialogLandscape);
    }

    if (orientation === 'portrait') {
      player.classList.add(CLASSES.portrait, CLASSES.videoPortrait);

      if (dialog) {
        dialog.classList.add(CLASSES.dialogPortrait);
      }

      if (modal) {
        modal.setAttribute('data-auth-video-orientation', 'portrait');
      }

      return;
    }

    player.classList.add(CLASSES.landscape, CLASSES.videoLandscape);

    if (dialog) {
      dialog.classList.add(CLASSES.dialogLandscape);
    }

    if (modal) {
      modal.setAttribute('data-auth-video-orientation', 'landscape');
    }
  }

  function detectVideoRatio(player) {
    if (!player || !player.videoWidth || !player.videoHeight) return;

    var ratio = player.videoWidth / player.videoHeight;
    var orientation = ratio < 1 ? 'portrait' : 'landscape';

    applyVideoOrientation(player, orientation);
  }

  function pauseVideo(modal) {
    var player = modal ? modal.querySelector(SELECTORS.player) : null;

    if (!player) return;

    player.pause();

    try {
      player.currentTime = 0;
    } catch (error) {}
  }

  function playVideo(modal) {
    var player = modal ? modal.querySelector(SELECTORS.player) : null;

    if (!player) return;

    modal.classList.add(CLASSES.loading);
    loadVideoSources(modal);

    var initialOrientation = modal.getAttribute('data-auth-video-orientation');

    if (initialOrientation === 'portrait' || initialOrientation === 'landscape') {
      applyVideoOrientation(player, initialOrientation);
    }

    var playPromise = player.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        modal.classList.remove(CLASSES.loading);
      });
    }
  }

  function focusModal(modal) {
    var dialog = modal.querySelector(SELECTORS.dialog);
    var focusable = getFocusableElements(modal);

    try {
      if (focusable.length > 0) {
        focusable[0].focus({ preventScroll: true });
      } else if (dialog) {
        dialog.focus({ preventScroll: true });
      }
    } catch (error) {}
  }

  function closeModal(modal, options) {
    var opts = options || {};
    var immediate = opts.immediate === true;
    var restoreFocus = opts.restoreFocus !== false;

    if (!modal) return;

    modal.classList.remove(CLASSES.open);
    modal.setAttribute('aria-hidden', 'true');
    pauseVideo(modal);

    if (state.closeTimer) {
      window.clearTimeout(state.closeTimer);
      state.closeTimer = null;
    }

    state.closeTimer = window.setTimeout(function () {
      modal.style.display = 'none';
      modal.classList.remove(CLASSES.loading);

      if (state.activeModal === modal) {
        state.activeModal = null;
      }

      if (!document.querySelector(SELECTORS.modal + '.' + CLASSES.open)) {
        lockBodyScroll(false);
      }

      if (
        restoreFocus &&
        state.lastFocusedElement &&
        typeof state.lastFocusedElement.focus === 'function'
      ) {
        try {
          state.lastFocusedElement.focus({ preventScroll: true });
        } catch (error) {}
      }

      state.lastFocusedElement = null;
    }, immediate ? 0 : 240);
  }

  function openModal(modal, trigger) {
    if (!modal) return;

    if (state.activeModal && state.activeModal !== modal) {
      closeModal(state.activeModal, { immediate: true, restoreFocus: false });
    }

    state.activeModal = modal;
    state.lastFocusedElement = trigger || document.activeElement;

    if (state.closeTimer) {
      window.clearTimeout(state.closeTimer);
      state.closeTimer = null;
    }

    appendModalToBody(modal);
    syncVisualViewport(modal);

    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');

    var player = modal.querySelector(SELECTORS.player);
    var initialOrientation = modal.getAttribute('data-auth-video-orientation');

    if (player && (initialOrientation === 'portrait' || initialOrientation === 'landscape')) {
      applyVideoOrientation(player, initialOrientation);
    }

    lockBodyScroll(true);

    requestAnimationFrame(function () {
      syncVisualViewport(modal);
      modal.classList.add(CLASSES.open);
      playVideo(modal);

      window.setTimeout(function () {
        focusModal(modal);
      }, 80);
    });
  }

  function closeOpenModals() {
    document.querySelectorAll(SELECTORS.modal + '.' + CLASSES.open).forEach(function (modal) {
      closeModal(modal);
    });
  }

  function trapFocus(event, modal) {
    if (event.key !== 'Tab') return;

    var focusable = getFocusableElements(modal);

    if (focusable.length === 0) {
      event.preventDefault();
      focusModal(modal);
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
      return;
    }

    if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  }

  function bindTriggers(section) {
    section.querySelectorAll(SELECTORS.trigger).forEach(function (trigger) {
      if (trigger.dataset.authVideoTriggerBound === 'true') return;

      trigger.dataset.authVideoTriggerBound = 'true';

      trigger.addEventListener('click', function () {
        var targetId = trigger.getAttribute('data-auth-video-target');
        var modal = targetId ? document.getElementById(targetId) : null;

        openModal(modal, trigger);
      });
    });
  }

  function bindCloseElements(scope) {
    scope.querySelectorAll(SELECTORS.close).forEach(function (closeElement) {
      if (closeElement.dataset.authVideoCloseBound === 'true') return;

      closeElement.dataset.authVideoCloseBound = 'true';

      closeElement.addEventListener('click', function () {
        closeModal(closeElement.closest(SELECTORS.modal));
      });
    });
  }

  function bindPlayers(scope) {
    scope.querySelectorAll(SELECTORS.player).forEach(function (player) {
      if (player.dataset.authVideoPlayerBound === 'true') return;

      player.dataset.authVideoPlayerBound = 'true';

      player.addEventListener('loadedmetadata', function () {
        detectVideoRatio(player);
      });

      player.addEventListener('canplay', function () {
        var modal = player.closest(SELECTORS.modal);

        if (modal) {
          modal.classList.remove(CLASSES.loading);
        }
      });

      player.addEventListener('playing', function () {
        var modal = player.closest(SELECTORS.modal);

        if (modal) {
          modal.classList.remove(CLASSES.loading);
        }
      });

      player.addEventListener('waiting', function () {
        var modal = player.closest(SELECTORS.modal);

        if (modal) {
          modal.classList.add(CLASSES.loading);
        }
      });

      player.addEventListener('error', function () {
        var modal = player.closest(SELECTORS.modal);

        if (modal) {
          modal.classList.remove(CLASSES.loading);
        }
      });

      if (player.readyState >= 1) {
        detectVideoRatio(player);
      }
    });
  }

  function bindModals(section) {
    section.querySelectorAll(SELECTORS.modal).forEach(function (modal) {
      if (modal.dataset.authVideoModalBound === 'true') return;

      modal.dataset.authVideoModalBound = 'true';

      appendModalToBody(modal);
      bindCloseElements(modal);
      bindPlayers(modal);

      modal.addEventListener('click', function (event) {
        if (!event.target.closest(SELECTORS.dialog)) {
          closeModal(modal);
        }
      });
    });
  }

  function initSection(section) {
    if (!section) return;

    bindTriggers(section);
    bindModals(section);
  }

  function cleanupSection(section) {
    if (!section) return;

    var ownerId = section.getAttribute('data-auth-video-section-id');

    if (!ownerId) return;

    document.querySelectorAll(SELECTORS.modal + '[data-auth-video-owner="' + ownerId + '"]').forEach(function (modal) {
      closeModal(modal, { immediate: true, restoreFocus: false });
      modal.remove();
    });
  }

  function initAllSections() {
    document.querySelectorAll(SELECTORS.section).forEach(initSection);
  }

  function handleDocumentKeydown(event) {
    if (!state.activeModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(state.activeModal);
      return;
    }

    trapFocus(event, state.activeModal);
  }

  function handleViewportChange() {
    if (state.activeModal) {
      syncVisualViewport(state.activeModal);
    }
  }

  window.AuthenticityVideoPopup = {
    initAllSections: initAllSections,
    closeOpenModals: closeOpenModals
  };

  document.addEventListener('DOMContentLoaded', initAllSections);

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupSection(event.target);
  });

  document.addEventListener('keydown', handleDocumentKeydown);

  window.addEventListener('resize', handleViewportChange, { passive: true });

  window.addEventListener('orientationchange', function () {
    window.setTimeout(handleViewportChange, 250);
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handleViewportChange, { passive: true });
    window.visualViewport.addEventListener('scroll', handleViewportChange, { passive: true });
  }
})();